import Vue from 'vue'
import Vuex from 'vuex'

import aiAssistant from './modules/aiAssistant'
import aiDocuments from './modules/aiDocuments'
import admin from './modules/admin'
import archivedConversation from './modules/archivedConversation'
import chatTopic from './modules/chatTopic'
import conversation from './modules/conversation'
import coordination from './modules/coordination'
import createPersistedState from 'vuex-persistedstate'
import customer from './modules/customer'
import general from './modules/general'
import menu from './modules/menu'
import message from './modules/message'
import messageTemplate from './modules/messageTemplate'
import professional from './modules/professional'
import tag from './modules/tag'
import ticker from './modules/ticker'

const plugins = [createPersistedState()]

Vue.use(Vuex)
// const debug = process.env.NODE_ENV !== 'production'
// Vue.config.debug = debug
// Vue.config.warnExpressionErrors = true

export default new Vuex.Store({
  modules: {
    aiAssistant,
    aiDocuments,
    admin,
    archivedConversation,
    chatTopic,
    conversation,
    coordination,
    customer,
    general,
    menu,
    message,
    messageTemplate,
    professional,
    tag,
    ticker
  },
  plugins
})
